import React, { useRef } from 'react';
import { Field } from 'react-final-form';
import TextField from '../../_Shares/FormHelpers/TextField';
import LocationSelectField from '../../_Shares/Select/LocationSelect/Field';
import CheckBoxField from '../../_Shares/FormHelpers/CheckBoxField';

const DeliveryInfoForm = ({ values, onChange }) => {
    const locationInfo = useRef({
        cityName: '',
        districtName: '',
        wardName: '',
    });
    const onLocationChange = (s, field) => {
        locationInfo.current = {
            ...locationInfo.current,
            [`${field}`]: s.l_name,
        };

        if (onChange) {
            onChange(locationInfo.current);
        }
    };

    return (
        <>
            <h3 className="title-brand">THÔNG TIN GIAO HÀNG</h3>
            <form className="form-horizontal">
                <div className="form-group col-md-12">
                    <Field
                        name="customerName"
                        component={TextField}
                        className="form-control  space-20"
                        type="text"
                        label=" Họ và tên"
                        placeholder="Nhập họ tên..."
                        isRequired
                    />
                </div>
                <div>
                    <div className="form-group col-md-6">
                        <Field
                            name="email"
                            component={TextField}
                            className="form-control  space-20"
                            type="email"
                            label="Email"
                            placeholder="Nhập email..."
                            isRequired
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <Field
                            name="phoneNumber"
                            component={TextField}
                            className="form-control  space-20"
                            type="text"
                            label="Điện thoại"
                            placeholder="Nhập số điện thoại..."
                            isRequired
                        />
                    </div>
                </div>

                <div className="form-group col-md-12">
                    <Field
                        name="addressName"
                        component={TextField}
                        className="form-control  space-20"
                        type="text"
                        label="Tên địa chỉ giao hàng"
                        placeholder="Tên địa chỉ (Ví dụ: nhà, công ty...)"
                        isRequired
                    />
                </div>
                <div className="form-group">
                    <Field
                        name="address"
                        component={TextField}
                        className="form-control space-20"
                        type="text"
                        label="Địa chỉ"
                        placeholder="Nhập số nhà/đường ..."
                        isRequired
                    />
                </div>
                <div className="form-group">
                    <Field
                        name="cityId"
                        component={LocationSelectField}
                        parentId={'0'}
                        label={'Tỉnh/Thành phố'}
                        isRequired
                        placeHolder="Chọn Tỉnh/thành phố..."
                        onItemChange={(s) => onLocationChange(s, 'cityName')}
                    />
                </div>
                <div>
                    <div className="form-group col-md-6">
                        <Field
                            name="districtId"
                            component={LocationSelectField}
                            parentId={values.cityId}
                            label={'Quận/Huyện'}
                            isRequired
                            placeHolder="Chọn Quận/Huyện..."
                            onItemChange={(s) =>
                                onLocationChange(s, 'districtName')
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <Field
                            name="wardId"
                            component={LocationSelectField}
                            parentId={values.districtId}
                            label={'Phường/Xã'}
                            isRequired
                            placeHolder="Chọn Phường/Xã..."
                            onItemChange={(s) =>
                                onLocationChange(s, 'wardName')
                            }
                        />
                    </div>
                </div>
                <Field
                    name="isAutoRegister"
                    component={CheckBoxField}
                    label={'Tự động tạo tài khoản?'}
                />
                <span className="form-check space-50"></span>
            </form>
        </>
    );
};

DeliveryInfoForm.propTypes = {};

export default DeliveryInfoForm;
